var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgNext15X = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "34px",
  height: "34px",
  viewBox: "0 0 34 34",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "197FA971-E45D-494C-BE9C-22D6E7AE7230@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "\\uD83D\\uDD27-Workspace",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Webplayer-Icons",
  transform: "translate(-316.000000, -53.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-Next-Prev-Track",
  transform: "translate(316.000000, 53.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#010B3B",
  cx: 17,
  cy: 17,
  r: 17
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.000000, 9.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.06292312,2.95900958 L13.3612616,12.8408854 C13.6383115,13.2755672 13.5105256,13.8525398 13.0758438,14.1295898 C12.9259671,14.2251156 12.7519312,14.2758621 12.5742005,14.2758621 L-0.0224763804,14.2758621 C-0.537942147,14.2758621 -0.955809714,13.8579945 -0.955809714,13.3425287 C-0.955809714,13.164798 -0.905063242,12.9907621 -0.809537434,12.8408854 L5.48880102,2.95900958 C5.76585096,2.52432777 6.34282356,2.39654189 6.77750538,2.67359184 C6.89232457,2.7467733 6.98974166,2.84419039 7.06292312,2.95900958 Z",
  id: "Triangle",
  transform: "translate(6.275862, 8.000000) rotate(90.000000) translate(-6.275862, -8.000000) "
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 12.5517241,
  y: 3.69482223e-13,
  width: 1.44827586,
  height: 16,
  rx: 0.466666667
})))))));

const ForwardRef = /*#__PURE__*/forwardRef(SvgNext15X);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Next@1.5x.7f2718c3f1391d7f7aca0bf21a58a5c4.svg";